import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as env from "shared/env";
import { styles } from "../../add-campaign/styles";
import { RootState } from "redux/store";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { Dialog } from "component/shared/dialog";
import { getActiveLeads } from "redux/selector";
import { CreateCampaign } from "component/page/campaign/create-campaign";

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
	return {
		allLeads: getActiveLeads(state),
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({}, dispatch);

interface OwnProps {
	open: boolean;
	onClose: () => void;
}

type Props = OwnProps &
	WithStyles<typeof styles> &
	ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps>;

interface State {}

class Component extends React.Component<Props, State> {

	private submitFn: (() => void) | null = null;

	public constructor(props: Props) {
		super(props);
		this.state = {
		}
	}

	public render() {
		const { onClose, open } = this.props;

		return (
			<>
				<Dialog open={open} onClose={() => onClose()} scroll="paper" fullWidth={true} maxWidth="md">
					<Mui.DialogTitle>
						<Mui.Grid container direction="column" spacing={1}>
							<Mui.Grid item xs={12}>Add a Campaign</Mui.Grid>
						</Mui.Grid>
					</Mui.DialogTitle>
					<Mui.DialogContent>
						<CreateCampaign
							onSave={() => onClose()}
							onRegisterSubmit={(fn) => { this.submitFn = fn; }}
						/>
					</Mui.DialogContent>
					<Mui.DialogActions>
						<Mui.Button
							variant="outlined"
							color={"primary"}
							onClick={() => onClose()}
						>
							Cancel
						</Mui.Button>
						<Mui.Button
							variant="contained"
							color={"primary"}
							onClick={() => this.submitFn?.()}
						>
							Add
						</Mui.Button>
					</Mui.DialogActions>
				</Dialog>
			</>
		);
	}

}

export const AddCampaign = withStyles(connect(
	mapStateToProps,
	mapDispatchToProps,
)(Component), styles);
